//natives
import React from 'react';
import {
  Grid,
  Typography,
  Hidden,
  Link
} from '@material-ui/core/';
import Grupo from "../../mini_list/childrens/Modal_Mini_List/childrens/grupos/Grupo";


//components
import Modal_Right_Top from '../../../childrens/modal_right_top/.mixins/Modal_Right_Top';
import Mini_List from '../../../childrens/mini_list/.mixins/Mini_List';
import { Can } from '../../../../../../../util/Can';

//css
import useStyles from './styles';

const section = (props) => {
    const classes = useStyles();
    let tamanhoLeft = 4;
    let tamanhoRight = 8;
    if (!props.permissions["ver-lista-de-comunicados"] && !props.permissions["ver-lista-de-contatos"]) {
      tamanhoLeft = 0;
      tamanhoRight = 12;
    }

    return (
      <div className={classes.root}>
        <div className="container">
          <Grid container spacing={1}>
            <Hidden smDown>
              <Grid item xs={12}>
                <Typography variant="h5">Bem-vindo ao portal do fornecedor Tok&Stok</Typography>
              </Grid>
            </Hidden>
            <Grid item xs={12}>
              <Modal_Right_Top {...props}/>
            </Grid>

            <Can permissions={["gerenciar-pedidos.pendentes"]}>
              <Grid item sm={4} xs={12}>
                  <div>
                    <Mini_List title={'Pendências'} link={'/pendencias'} message={'pendencias'} pai={props}/>
                  </div>
              </Grid>
            </Can>

            <Can permissions={["ver-lista-de-comunicados"]}>
              <Grid item sm={4} xs={12}>
                  <div>
                    <Mini_List title={'Comunicados'} link={'/comunicado'} message={'comunicado'} pai={props}/>
                  </div>
              </Grid>
            </Can>

            <Can permissions={["ver-lista-de-contatos"]}>
              <Grid item sm={4} xs={12}>
                  <div>
                    <Grupo {...props} />
                  </div>
              </Grid>
            </Can>

            <Grid item sm={12} xs={12} className={classes.footer}>
              <Typography  className={classes.footerText}>
                {"Estok Comércio e Representações Ltda. Endereços: "}
                <Link
                  onClick={props.handleDialogEndereco}
                  className={classes.linkText}
                  href="#"
                >
                  Clique aqui.
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </div>
      </div>
    );
};

export default section;